<script setup>
import HeaderDropdowns from '~/components/Aggregates/Navigation/HeaderDropdownsUnauthenticated.vue';
import Logo from '~/assets/images/logos/Logo.vue';

const { data, error } = await useFetch('/api/site-settings', {});

if (error.value) {
  console.error('Fetching site settings failed with error: ' + error.value.message);
}
</script>
<template>
  <div class="flex min-h-screen flex-col justify-start">
    <div class="flex flex-col overflow-hidden text-stormcloud">
      <div class="container flex flex-row items-center justify-between gap-10 py-6">
        <nuxt-link href="/" class="transition hover:opacity-70">
          <Logo class="h-11 w-40" />
        </nuxt-link>
        <HeaderDropdowns />
      </div>
    </div>
    <main class="flex flex-1 flex-col bg-anti-flash-white">
      <slot />
    </main>
    <LazyNavigationFooter />
  </div>
</template>
